module.exports = __webpack_public_path__ + "img/chargingpoint-suggestion.9e886dc0.png";